'use client';

import { useEffect } from 'react';
import { logout } from '@/lib/auth';

const AUTH_PAGES = ['/login', '/verify-otp'];

/**
 * Sends the user back to the login page when Frappe rejects their token,
 * for example after logging out on another device revoked it.
 *
 * Frappe answers a revoked or invalid token with 401 and an
 * `AuthenticationError`; permission problems use 403, so they never trigger this.
 */
export default function SessionExpiryWatcher() {
  useEffect(() => {
    const originalFetch = window.fetch;
    let handled = false;

    const handleExpiredSession = async () => {
      if (handled || AUTH_PAGES.includes(window.location.pathname)) return;
      handled = true;
      await logout();
      window.location.replace('/login?expired=1');
    };

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      if (response.status === 401) {
        const input = args[0];
        const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
        const isOwnApi = new URL(url, window.location.origin).pathname.startsWith('/api/');

        if (isOwnApi) {
          const body = await response.clone().json().catch(() => null);
          if (body?.exc_type === 'AuthenticationError') {
            void handleExpiredSession();
          }
        }
      }

      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return null;
}
